<template>
  <v-text-field
    outlined
    dense
    class="rounded-lg mt-1 mini-text field-edit"
    :label="keyValue"
    :clearable="true"
    :value="modelValue"
    :hide-details="hideDetails"
    @input="$emit('input', $event || null)"
    @click:clear="$emit('input', null)"
  />
</template>

<script>

export default {
  name: 'StringInput',
  props: {
    modelValue: { type: String | null, required: true },
    keyValue: { type: String, required: true },
    hideDetails: {type: Boolean, default: false}
  },
}

</script>
